import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const ExploreLanding = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const trackAndRedirect = async () => {
      const token = searchParams.get("token");

      if (token) {
        try {
          // Track the explore click
          await supabase.functions.invoke("track-invitation-response", {
            body: {
              tracking_token: token,
              action_type: "explored",
            },
          });
        } catch (error) {
          console.error("Error tracking explore:", error);
        }
      }

      // Redirect to prototype site
      window.location.href = "https://prototype.ispai.io/intro";
    };

    trackAndRedirect();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-lg">Redirecting to iSPAI prototype...</p>
    </div>
  );
};

export default ExploreLanding;
